export default "__VITE_ASSET__D$ttXhZj__"